export interface Survey {
  survey_id: number;
}
